module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAKlBMVEUuMDArLS0sLi4rLS0uMDAsLi4uMDAuMDAuMDAuMDAuMDAAAAAtLy8uMDA4BSQIAAAADHRSTlNt9MXzbsORE0gEKACMgTKbAAAAaUlEQVR42u3SSw6AIAwEUBToB+v9r+uqqSw6ujSRWb8EOm05XmWxxX7F9nNKT9iY2cgepbui9G9soYzzEVqwBibVzVVVVIg4E9xb9zIAi1IGYFEKgS1EKcbPOy1eBmZaq+YsIvLBswS5AEY4PjgldHeFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_desc@2x.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_desc@2x.png
// module chunks = 2